module.exports = __webpack_public_path__ + "static/media/Logo_One-to-One_FAICO.4be78181.png";